module.exports = __webpack_public_path__ + "img/土茯苓.5cb14e9b.jpg";